'use strict'

import ApiService from '@/app/service/api/api-service'

export default {
  install (Vue, opts = {}) {
    const http = opts.http
    const pageManager = opts.pageManager
    const store = opts.store

    Vue.prototype.$service = new ApiService(http, store, pageManager)
  }
}
